/* eslint-disable */
//tslint:disable

import { ITariffIdentificatorSchema } from '../publish_term/TariffIdentificatorSchema';

export interface IPublishTermSchema {
  /** Количество дней **/
  days?: number | null;
  /** Стоимость услуги, указанная пользователем **/
  dynamicPrice?: number | null;
  /** Услуга обязательна к применению **/
  isCompulsory?: boolean | null;
  /** Список услуг **/
  services?: EServices[] | null;
  /** Идентификатор тарифа **/
  tariffIdentificator?: ITariffIdentificatorSchema | null;
  /** Тип тарификации **/
  type?: EType | null;
  /** Счёт размещения **/
  moneySource?: EMoneySource;
  /** Токен услуги **/
  token?: string | null;
}

export enum EServices {
  /** Аукцион **/
  Auction = 'auction',
  /** Колтрекинг **/
  Calltracking = 'calltracking',
  /** CPL Колтрекинг **/
  CplCalltracking = 'cplCalltracking',
  /** Спрос **/
  Demand = 'demand',
  /** Пакет заявок **/
  DemandPackage = 'demandPackage',
  /** Бесплатная публикация **/
  Free = 'free',
  /** Выделение цветом **/
  Highlight = 'highlight',
  /** Платная публикация **/
  Paid = 'paid',
  /** Премиум-публикация **/
  Premium = 'premium',
  /** Tоп-публикация **/
  Top3 = 'top3',
}
export enum EType {
  /** Ограниченная по дням публикация, подневная тарификация **/
  DailyLimited = 'dailyLimited',
  /** Бессрочная публикация, подневная тарификация **/
  DailyTermless = 'dailyTermless',
  /** Тарификация за весь период **/
  Periodical = 'periodical',
}

export enum EMoneySource {
  /** Собственные средства **/
  Self = 'self',
  /** Средства агентства **/
  Master = 'master',
}
